module.exports = __webpack_public_path__ + "media/อื้มมมม_อาหร่อยย.f525e0a7.mp3";